import React, {useEffect, useState} from 'react'
import { Box, Stack, Button, Typography, Grid, useMediaQuery } from '@mui/material'
import IntroBgImg from "../../Icons/IntroBgImg.svg"
import AboutUsImg from "../../Icons/AboutUsImg.svg"
import PlantsImg from "../../Icons/Intro/PlantsImg.svg"
import { ReactComponent as OurMissionIcon } from "../../Icons/Intro/OurMissionIcon.svg"
import { ReactComponent as ValuePropositionIcon } from "../../Icons/Intro/ValuePropositionIcon.svg"
import { ReactComponent as CommityValueIcon } from "../../Icons/Intro/CommityValueIcon.svg"
import AffordabilityImg from "../../Icons/Intro/Affordability.svg"
import ConvenienceImg from "../../Icons/Intro/Convenience.svg"
import ComfortableImg from "../../Icons/Intro/Comfortable.svg"
import { DocumentTitleChange } from '../../CommonComponents/Title'
import './Intro.css'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// import IntroBgImg from "../../assets/intro.webp"
// import AboutUsImg from "../../assets/hand.webp"

export default function Intro() {
    const isMobile = useMediaQuery('(max-width:600px)');
    const isTablet = useMediaQuery('(min-width:600px) and (max-width:960px)');
    const [aboutUsData, setAboutAsData] = useState({})
    const language = useSelector((state) => state.language.language)
    const styles = useSelector((state) => state.styles)
    const navigate = useNavigate()

    const [data, setData] = useState([
        {
            image : 'https://s1.1zoom.me/big0/643/Singapore_Marina_Bay_484042.jpg',
            title : 'Excellent Location',
            description : 'The hostels are close to the metro stations and have convenient transportation, making it convenient for students to attend classes and participate in on-campus activities.'
        },
        {
            image : 'https://ik.imagekit.io/tvlk/generic-asset/dgXfoyh24ryQLRcGq00cIdKHRmotrWLNlvG-TxlcLxGkiDwaUSggleJNPRgIHCX6/hotel/asset/10023195-c239d73187d7c74d477e635a1be50ca3.jpeg',
            title : 'Fully Equipped',
            description : 'The hostels are equipped with basic furniture such as beds, desks, and wardrobes, and provide Internet access so that students can study and rest comfortably.'
        },
        {
            image : 'https://edudelphi.com/wp-content/uploads/2021/11/cyber-security-best-practices-1280x720-1.jpg',
            title : 'Security',
            description : 'We attach great importance to the safety of students. There is a security monitoring system in the hostel building, and dedicated management personnel are responsible for maintaining order and safety.'
        },
        {
            image : 'https://www.xwa.edu.sg/wp-content/uploads/happy-university-students.jpg',
            title : 'Social space',
            description : 'The hostels provide shared social space and leisure space for communication and interaction between students.'
        },
        {
            image : 'https://www.xwa.edu.sg/wp-content/uploads/blog-personalised-learning-header.jpg',
            title : 'Learning support',
            description : 'The hostels have study spaces that provide a quiet study environment to help students concentrate on their studies.'
        },
        {
            image : 'https://www.science.nus.edu.sg/wp-content/uploads/2022/09/1920_1a.jpeg',
            title : 'Social activities',
            description : 'We regularly organize various activities to provide students with a rich and colorful campus life experience and promote communication and friendship between each other.'
        },
        {
            image : 'https://onecms-res.cloudinary.com/image/upload/s--wFcKg50E--/c_crop,h_900,w_1600,x_0,y_9/c_fill,g_auto,h_676,w_1200/f_auto,q_auto/v1/mediacorp/cna/image/2024/01/23/springcleaning_1.png',
            title : 'Management and service',
            description : 'A professional management team provides students with round-the-clock service and support to resolve residential issues and needs.'
        },
    ])
    // useEffect(() => {
    //     DocumentTitleChange('Intro')
    // }, [])

    const getAboutUs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}get-about-us`)
            console.log(response)
            setAboutAsData(response?.data?.data[0])
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAboutUs()
    }, [])

    console.log(process.env.REACT_APP_FILE_PATH + aboutUsData?.images?.header_image)

    return (
        <Box sx={{mt : '60px'}}>

            <Box sx={{ backgroundColor: "", px :{xs : 3, lg : '60px'}, py : {lg : '50px'}, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Typography p={2} width="fit-content" variant="h6_1" color="primary" border="1px solid #27BAC4" padding="10px 50px" borderRadius="50px" letterSpacing="1.1px" sx={{...styles.h2}}>{aboutUsData?.header?.[language]?.heading || '-'}</Typography>
                <Stack sx={{display : 'flex', flexDirection : {xs : 'column', lg :'row'}, flexWrap : {xs : 'wrap', lg : 'nowrap'}, gap: '50px'}} mt={'50px'}>
                    <Box sx={{
                        width : {xs : '100%', lg : '40%'}, 
                        height : {xs : '250px',lg : 'auto'}, 
                        backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + aboutUsData?.images?.header_image})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        borderRadius : '8px'
                        }}>
                    {/* <Box component="img" src={`${process.env.REACT_APP_FILE_PATH}/${aboutUsData?.images?.header_image}`} sx={{ width: "100%", height: "100%", borderRadius : '8px' }}></Box> */}
                    </Box>
                    {/* <Box
                    style={{
                        width : '40%',
                        height : '100%',
                        border : '1px solid black',
                        overflow : 'hidden',
                        backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + aboutUsData?.images?.header_image})`
                    }}
                    >

                    </Box> */}
                    <Stack sx={{width : {lg : '57%', xs : '100%'}}} mt={0} rowGap={4} justifyContent="center">
                        <Typography sx={{...styles.subheadingDescription}}>{aboutUsData?.description?.[language]?.line1 || '-'}</Typography>
                        
                        <Typography sx={{ lineHeight: "28px", ...styles.subheadingDescription, textAlign: "justify" }} >{aboutUsData?.description?.[language]?.line2 || '-'}</Typography>
                        
                        <Typography sx={{ lineHeight: "28px", ...styles.subheadingDescription, textAlign: "justify" }} >{aboutUsData?.description?.[language]?.line3 || '-'}</Typography>
                    </Stack>
                </Stack>
            </Box>


            <Box sx={{ mt : '60px', backgroundColor: "#E9F8F9", px: {xs : 2, lg : '60px'}, py : '50px',display: "flex", flexDirection: 'column', alignItems: "center", justifyContent: "center" }}>
                
                <Typography sx={{mt : {xs : 4, lg : 0}}} p={2} width="fit-content" variant="h6_1" color="primary" border="1px solid #27BAC4" padding="10px 50px" borderRadius="50px" letterSpacing="1.1px">{aboutUsData?.why_choose?.[language]?.whyChoose || '-'}</Typography>
                    
                    <Box sx={{display : 'flex', justifyContent : 'space-between', flexDirection : {xs : 'column', lg : 'row'}, mt : 5}}>
                    <Box px={{xs : 0, lg: 0, display : 'flex', gap : 50, flexWrap : 'wrap', justifyContent : 'center'}}>
                    {Object.entries(aboutUsData?.list_data?.[language] || {}).map(([key, con], i) => (
                            <Box key={i} sx={{ width: { xs: '100%', sm: '70%', md: '70%', lg: '30.8%' }}}>
                                {/* <Box
                                component="img"
                                sx={{ width: '100%', borderRadius: '8px' }}
                                src={`${process.env.REACT_APP_FILE_PATH}${aboutUsData?.images?.[key]}`}
                                alt={con.heading}
                                /> */}
                                <Box 
                                sx={{
                                    width : '100%',
                                    height : '250px', 
                                    backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + aboutUsData?.images?.[key]})`,
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                    borderRadius : '8px'
                                }}
                                />
                                <Box sx={{width : '100%'}}>
                                <Typography
                                
                                pb={{ xs: 0.3, lg: 1 }}
                                my={2}
                                sx={{
                                    width: 'fit-content',
                                    fontWeight: 700,
                                    borderBottom: '3px solid #b0b6ce',
                                    ...styles.h2,
                                    color : '#1A2461'
                                }}
                                >
                                {con.heading}
                                </Typography>
                                <Typography px={0} sx={{...styles.subheadingDescription, color : '#1A2461'}} textAlign="justify">
                                {con.description}
                                </Typography>
                                </Box>
                            </Box>
                            ))}
                        
                    </Box>
                   
               

                    </Box>
            </Box>
            
            <Box sx={{mt : 5, mb : 3, display : 'flex', justifyContent : 'center', alignItems : 'center', width : '100%'}}>
            <Box sx={{width : '92%', height : {xs : '250px', sm : '450px', md : '580px', lg : '400px'}}}>
            <iframe src="https://drive.google.com/file/d/1ZYqukvjduDiUXG-pQSeiKPLiljQ6STru/preview" style={{width:"100%", height:"100%"}} allow="autoplay"></iframe>
            </Box>
            </Box>


            <Stack mb={7} mt={7} direction={{xs : 'column' , lg : "row"}} justifyContent="space-between" alignItems="center" mx={{xs : 2, lg : 7}} p={4} sx={{ backgroundColor: "#1A2461", borderRadius: "20px" }}>
                <Stack gap="10px">
                    <Typography sx={{cursor : 'pointer', ...styles.button}} onClick={()=> navigate('/application')} width="fit-content" color="#FFFFFF" border="1px solid #FFFFFF" borderRadius="50px" letterSpacing="1.1px">{aboutUsData?.bottom_card?.[language]?.Apply_Now || '-'}</Typography>
                    <Typography variant="h2" color="#FFFFFF" sx={{ fontWeight: 500 }}>{aboutUsData?.bottom_card?.[language]?.Start_new_life || '-'}</Typography>
                    {/* <Typography variant="h4_2" color="#FFFFFF">We make it happen</Typography> */}
                </Stack>
                <Button onClick={() => navigate('/application')} variant="contained" sx={{width : {xs : '100%', sm : '55%', lg : '12%'}, marginTop : {xs : '15px', lg : 0}}}>{aboutUsData?.bottom_card?.[language]?.fill_form || '-'}</Button>
            </Stack>
        </Box >
    )
}
